import React from 'react';
import cn from 'classnames';
import { Button } from '@lt/components';

import { i18n } from '@lt/localization';
import { FLIGHT_CLASSES } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';

import type { FlightClass } from '../../types/flights';

import styles from './flightClassSwitcher.module.css';

interface FlightClassSwitcherProps {
  flightClass: FlightClass;
  economyCount: number;
  businessCount: number;
  setFlightClass: (flightClass: FlightClass) => void;
}

class FlightClassSwitcher extends React.PureComponent<FlightClassSwitcherProps> {
  constructor(props) {
    super(props);

    this.handleClassChange = this.handleClassChange.bind(this);
  }

  handleClassChange(event) {
    const { id: classType } = event.target;
    const { setFlightClass } = this.props;
    setFlightClass(classType);
  }

  render() {
    const { flightClass, economyCount, businessCount } = this.props;
    const hasEconomy = economyCount > 0;
    const hasBusiness = businessCount > 0;
    return (
      <div className={styles.container}>
        <Button
          functional
          size="none"
          id={FLIGHT_CLASSES.ECONOMY}
          onClick={this.handleClassChange}
          disabled={!hasEconomy}
          className={cn(styles.filter, {
            [styles.selectedFilter]: flightClass === FLIGHT_CLASSES.ECONOMY,
            [styles.disabledFilter]: !hasEconomy,
          })}
        >
          {hasEconomy
            ? i18n.t('checkout.flight.economy.title')
            : i18n.t('checkout.flight.economy.noTicket')}
        </Button>
        <Button
          functional
          size="none"
          id={FLIGHT_CLASSES.BUSINESS}
          onClick={this.handleClassChange}
          disabled={!hasBusiness}
          className={cn(styles.filter, {
            [styles.selectedFilter]: flightClass === FLIGHT_CLASSES.BUSINESS,
            [styles.disabledFilter]: !hasBusiness,
          })}
        >
          {hasBusiness
            ? i18n.t('checkout.flight.business.title')
            : i18n.t('checkout.flight.business.noTicket')}
        </Button>
      </div>
    );
  }
}

export default FlightClassSwitcher;
